import { EventBillingInfo } from "../Common/types";
import { resolveWithBody } from "./Utils/utils";

export default {
    init(promiseRequest) {
        return {
            getEventCostBreakdown(eventId) {
                return promiseRequest({
                    url: `/api/admin/events/${eventId}/cost-breakdowns`,
                    json: true,
                    method: "get",
                }).then(resolveWithBody());
            },
            getEventBillingInfo(eventId): Promise<EventBillingInfo> {
                return promiseRequest({
                    url: `/api/superadmin/events/${eventId}/billing-infos`,
                }).then(resolveWithBody());
            },
        };
    },
};
